/* build/tpl */
import deps from './deps/reduceDeep.js';
import getReduceDeep from './getReduceDeep.js';
export default getReduceDeep(deps);
